import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Socket } from 'ngx-socket-io';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../services/users.service';
import casinoDb from '../casinodb.json';
import { Router } from "@angular/router";
import { Location } from '@angular/common';
@Component({
  selector: 'app-diamondtable-url',
  templateUrl: './diamondtable-url.component.html',
  styleUrls: ['./diamondtable-url.component.scss']
})
export class DiamondtableUrlComponent implements OnInit, OnDestroy {
  gameId: any;
  loader: boolean = false;
  userDetails: any;
  iframUrl: any;
  amountId: any;
  depWith: any;
  casinoBal: any = 0;
  walletBalance: any = 0;
  amount: string = '';
  casino: any;
  dauble: any;
  single: any;
  diamondlog: any;

  constructor(private socket: Socket, private router: Router, public sanitizer: DomSanitizer, public _location: Location, public httpClient: UsersService, private toastr: ToastrService) {
    this.userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    this.casino = JSON.parse(localStorage.getItem('casinoDb'));
    this.single = this.casino?.gameId;
  }

  ngOnInit(): void {
    if (this.userDetails) {
      this.settings();
      this.getUserBalance();
      var data = { "id": this.userDetails.details._id, "name": this.userDetails.details.username };
      this.getAuth(data);

    }
  }
  backClicked() {
    // console.log('test')
    this._location.back();
  }
  getAuth(data) {
    this.httpClient.SocketPost("lobby-url", data).subscribe((res: any) => {
      if (res) {
        console.log(res);
        // Construct safe iframe URL
        //const unsafeUrl = `https://lobbyc.allpanealexch.com/${this.single}/?host_id=diamond222&token=${res.response.user}`;
        const unsafeUrl = `https://d222lobby.aobexch.com/${this.single}/?host_id=diamond222&token=${res.response.user}`;
        // console.log(unsafeUrl);
        this.iframUrl = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
      }
    })
  }

  efresh(): void {
    this.router.navigateByUrl("/refresh", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(this._location.path())]);
    });
    if (sessionStorage.getItem('loginStatus') === "true") {
      this.getUserBalance();
    }
  }

  settings() {
    //this.userDetails = await this.getDetials();
    const data = { user_id: this.userDetails.details._id };

    this.httpClient.SocketPost("menusetting", data).subscribe((res: any) => {
      var available_events = res;
      console.log(res);
      if (available_events) {
        // this.wallet_status=available_events?.manager?.wallet_status;
        var available_event = available_events.eventTypes;
        const available_user = available_events.user.availableEventTypes;

        // Map event types to menu variables
        const eventMap = {
          'd1': 'diamondlog',
          // 'aviator' : 'aviatorlog'
        };

        // Initialize menu visibility
        Object.keys(eventMap).forEach((id) => {
          const menuKey = eventMap[id];
          const isEventAvailable = available_user.includes(id);
          const event = available_event.find((data) => data.eventType.id === id);
          console.log(isEventAvailable);
          this[menuKey] = event?.visible_status && isEventAvailable;

        });
      }
    });
  }
  getUserBalance() {
    const userdata = {
      user: {
        _id: this.userDetails._id,
        key: this.userDetails.key,
        token: this.userDetails.verifytoken,
        details: {
          username: this.userDetails.details.username,
          role: this.userDetails.details.role,
          status: this.userDetails.details.status,
        },
      }
    };

    this.socket.emit('get-user', userdata);

    this.socket.on('get-user-success', (function (data: any) {
      if (data) {
        this.walletBalance = data.balance;
        this.getCasinoBal();
      }
    }).bind(this));

  }

  getCasinoBal() {
    const userdata = {
      user: {
        _id: this.userDetails._id,
        key: this.userDetails.key,
        details: {
          username: this.userDetails.details.username,
          role: this.userDetails.details.role,
          status: this.userDetails.details.status,
        },
      }
    };
    this.socket.emit('get-userbalance', userdata);

    this.socket.on('get-balance-success', (function (data: any) {

      if (data) {
        this.casinoBal = data.amount;
      }
    }).bind(this));

  }


  back() {
    this._location.back();
  }

  // Show modal function 
  showModal() {
    // Get modal and buttons 
    const modal = document.getElementById('modal');
    modal.style.display = 'flex';
  }

  // Hide modal function 
  hideModal() {
    const modal = document.getElementById('modal');
    modal.style.display = 'none';
  }
  ngOnDestroy() {
    localStorage.removeItem('casinoDb');
    this.socket.removeAllListeners();
  }

}
